export const SVG_NAMESPACE = 'http://www.w3.org/2000/svg'
